import React, { Suspense, useEffect } from 'react';
import Auth from "./hoc/auth";
import { Routes, Route } from 'react-router-dom';
// pages for this product
import { FlowChart } from './components/views/FlowChart';
import TopicsPage from './components/views/TopicsPage';
import NotFoundPage from './components/views/NotFoundPage';
import { ReactFlowProvider } from '@xyflow/react';
import WikiPage from './components/views/WikiPage';
import UserPage from './components/views/UserPage';
import LoginPage from './components/views/LoginPage';
import PrivacyPolicyPage from './components/views/PrivacyPolicyPage';
import AuthCallback from './components/views/AuthCallback';
import { message } from 'antd'
import { useFlowStore } from './components/store';
import TermsOfServicePage from './components/views/TermsOfServicePage';

//null   Anyone Can go inside
//true   only logged in user can go inside
//false  logged in user can't go inside



const App: React.FC = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { clearError, clearSuccess, error, success } = useFlowStore()

  const errorDisplayer = (content: string | React.ReactNode) => {
    messageApi.open({
      type: 'error',
      content: content,
      duration: 2.5,
    })
    .then(() => clearError())
  };

  const successDisplayer = (content: string) => {
    messageApi.open({
      type: 'success',
      content: content,
      duration: 2.5,
    })
    .then(() => clearSuccess());
  };

  useEffect(() => {
    if (error != null) errorDisplayer(error)
    if (success != null) successDisplayer(success)
  }, [error, success])
  return (
    <Suspense fallback={(<div>Loading...</div>)}>
      <div style={{ width: '100%', height: '100vh' }}>
      {contextHolder}
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Auth option={false}><LoginPage /></Auth>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/auth/:provider/callback" element={<AuthCallback />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/topics" element={<Auth option={false}><TopicsPage /></Auth>} />
        <Route path="/:topic/map" element={<Auth option={false}><ReactFlowProvider><FlowChart /></ReactFlowProvider></Auth>} />
        <Route path="/:topic/wiki-page/:nid" element={<Auth option={false}><WikiPage /></Auth>} />
        <Route path="user-page/:id" element={<Auth option={false}><UserPage /></Auth>} />

        {/* Protected routes */}

        {/* Catch-all route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </div>
    </Suspense>
  );
};

export default App;
